import script from "./EntriesListTitleInfoDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EntriesListTitleInfoDialog.vue?vue&type=script&setup=true&lang=js"

import "./EntriesListTitleInfoDialog.vue?vue&type=style&index=0&id=1c6df9e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c6df9e6"]])

export default __exports__